import type { FaqItem } from '@/components/common/FaqList'
import { messagesNow } from '@/i18n'
import { PRICE_RUB_MIN, PRICE_USD_MIN } from './coursePatch'
import { messages } from './messages'

// Ответы собраны только из того, что студия уже знает наверняка: тексты вкладки
// «Монетизация», пороги платёжных систем (`coursePatch`) и правила триала. Про выплаты,
// налоги и сроки здесь нарочно нет ничего — это решает бэк и бухгалтерия, а не студия.

type Msgs = (typeof messages)['ru']

/** Вопрос и ответ — геттеры: читают язык интерфейса в момент обращения. */
const faq = (question: (m: Msgs) => string, answer: (m: Msgs) => string): FaqItem => ({
  get question() {
    return question(messagesNow(messages))
  },
  get answer() {
    return answer(messagesNow(messages))
  },
})

export const SUBSCRIPTION_FAQ: FaqItem[] = [
  faq(
    (m) => m.faqSubPayoutQ,
    (m) => m.faqSubPayoutA,
  ),
  faq(
    (m) => m.faqSubWhoQ,
    (m) => m.faqSubWhoA,
  ),
  faq(
    (m) => m.faqSubViewsQ,
    (m) => m.faqSubViewsA,
  ),
  // Ответ бэка (п.10): по окончании подписки доступ снимается со всех курсов
  // из неё, независимо от прогресса.
  faq(
    (m) => m.faqSubEndsQ,
    (m) => m.faqSubEndsA,
  ),
]

export const STANDALONE_FAQ: FaqItem[] = [
  faq(
    (m) => m.faqSaleFeeQ,
    (m) => m.faqSaleFeeA,
  ),
  faq(
    (m) => m.faqSaleTwoPricesQ,
    (m) => m.faqSaleTwoPricesA,
  ),
  faq(
    (m) => m.faqSaleMinQ,
    (m) => m.faqSaleMinA(PRICE_RUB_MIN, PRICE_USD_MIN.toFixed(2)),
  ),
  faq(
    (m) => m.faqSaleBuyerQ,
    (m) => m.faqSaleBuyerA,
  ),
  faq(
    (m) => m.faqSaleTrialQ,
    (m) => m.faqSaleTrialA,
  ),
]
